var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeadScienceIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 42,
    viewBox: "0 0 37 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4229_5240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.9812 5.97949H11.3947V30.5369H22.9203V35.2737H5.9812V5.97949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5558 22.6572L17.9434 21.9368C18.6201 23.3557 20.1699 24.1852 22.2218 24.1852C24.3829 24.1852 25.6271 23.4648 25.6271 22.1769C25.6271 18.5534 14.167 21.5002 14.2325 14.2313C14.298 10.9569 17.5286 8.7959 22.0472 8.7959C25.8017 8.7959 29.1634 10.5422 30.0583 13.3581L25.7362 14.1221C25.1905 12.8779 23.7935 12.1575 22.1782 12.1575C20.1699 12.1575 19.013 12.8561 19.013 14.0566C19.013 17.6802 30.5167 14.4277 30.5167 21.7185C30.5167 25.3421 27.3079 27.5905 22.2218 27.5905C17.6814 27.6123 14.4289 25.6259 13.5558 22.6572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.02595 1.02498H35.7337V40.2076H1.02595V1.02498ZM0 -0.000976562V1.02498V40.2076V41.2336H1.02595H35.7337H36.7597V40.2076V1.02498V-0.000976562H0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4229_5240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.7597,
    height: 41.2346,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadScienceIconWhite);
export default __webpack_public_path__ + "static/media/lead-science-icon-white.2d373c37.svg";
export { ForwardRef as ReactComponent };